import TicketRootCausesSummary from './TicketRootCausesSummary';

export default TicketRootCausesSummary;
